export const duplicateFoodRules = {
  threshold: 0.8,
  negatedExtra: /(?:^|[^\p{L}])не\s+(?:добавь|добавить|добавим|запиши|записать)/iu,
  explicitExtra: /(?:добавь|добавить|добавим|запиши|записать)\s+(?:мне\s+)?ещ[её](?=$|[^\p{L}])/iu,
  prompt: "Перед добавлением позиции проверяем сходство названий с текущим приёмом пищи. При сходстве от 80% спрашиваем «Добавить» или «Изменить». Явное «добавь ещё» разрешает отдельную порцию без вопроса. До выбора изменения не сохраняются. Крестик отменяет всю текущую команду. При нескольких совпадениях пользователь выбирает изменяемую позицию.",
};
